import React from 'react';
import { injectIntl } from 'react-intl';

import { ErrorPage } from '../ErrorPage';
import locale from './locale';

export const NoPermissionsError = injectIntl(({ intl: { formatMessage } }) => (
  <ErrorPage header={formatMessage(locale.header)} message={formatMessage(locale.message)} navbar />
));
